import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploaderComponent } from './uploader.component';
import { UploadService } from './upload.service';
import { BytesToSizePipe } from './bytes-to-size.pipe';
import { LayoutService } from '../services';
export * from './upload.model';
export * from './upload.provider';

@NgModule({
  declarations: [UploaderComponent, BytesToSizePipe],
  imports: [CommonModule],
  exports: [UploaderComponent],
  providers: [UploadService, LayoutService]
})
export class UploaderModule {}
